import type { LocationQuery } from "vue-router";

const DEMO_MODE_QUERY_PARAM = "demo";

const TRUTHY_VALUES = new Set(["1", "true", "yes"]);

/**
 * Detects `?demo=1` (or `true`/`yes`) so views can fall back to dummy content
 * when a live endpoint is unavailable, without a rebuild or env change.
 */
export function isDemoModeEnabled(query: LocationQuery): boolean {
  const raw = query[DEMO_MODE_QUERY_PARAM];
  const value = Array.isArray(raw) ? raw[0] : raw;
  return typeof value === "string" && TRUTHY_VALUES.has(value.toLowerCase());
}
